<nz-form-control *ngIf="recordProperty !== undefined">
  <nz-row>
    <nz-col nzSpan="12">
      <nz-select [(ngModel)]="selectedMonth" (ngModelChange)="ccValidityValueChanged();">
        <nz-option nzValue="" [nzLabel]="'Month' | locale"></nz-option>
        <nz-option [nzValue]="'01'" [nzLabel]="'01'"></nz-option>
        <nz-option [nzValue]="'02'" [nzLabel]="'02'"></nz-option>
        <nz-option [nzValue]="'03'" [nzLabel]="'03'"></nz-option>
        <nz-option [nzValue]="'04'" [nzLabel]="'04'"></nz-option>
        <nz-option [nzValue]="'05'" [nzLabel]="'05'"></nz-option>
        <nz-option [nzValue]="'06'" [nzLabel]="'06'"></nz-option>
        <nz-option [nzValue]="'07'" [nzLabel]="'07'"></nz-option>
        <nz-option [nzValue]="'08'" [nzLabel]="'08'"></nz-option>
        <nz-option [nzValue]="'09'" [nzLabel]="'09'"></nz-option>
        <nz-option [nzValue]="'10'" [nzLabel]="'10'"></nz-option>
        <nz-option [nzValue]="'11'" [nzLabel]="'11'"></nz-option>
        <nz-option [nzValue]="'12'" [nzLabel]="'12'"></nz-option>
      </nz-select>
    </nz-col>
    <nz-col nzSpan="12">
      <nz-select [(ngModel)]="selectedYear" (ngModelChange)="ccValidityValueChanged();">
        <nz-option nzValue="" [nzLabel]="'Year' | locale"></nz-option>
        <nz-option *ngFor="let year of years" [nzLabel]="year" [nzValue]="year.toString()"></nz-option>
      </nz-select>
    </nz-col>
  </nz-row>
</nz-form-control>
